export default __webpack_public_path__ + "static/media/img_vision_03_w.7d93aed5.png";